import React from "react";
import { useTranslation } from "react-i18next";

export default function AutomaticTestingToolHeader(props) {

    const { t } = useTranslation();

    return (
        <>

            <div css={`
                font-size:24px;
                color:#2E2E38;
            `}>
                {props.title}
            </div>
            <div css={`
                font-size:16px;
                color:#2E2E38;
                margin-top:12px;
                `}>
                <span>
                {props.description}
                    </span>
            </div>
        </>
    )

}